module.exports = __webpack_public_path__ + "Lato-Semibold.8bb939ef88123e279c29.eot";


//////////////////
// WEBPACK FOOTER
// /Users/davidkross/Project/TaiwaneseTutor/front-end/TaiwaneseTutor/src/assets/fonts/Lato/fonts/Lato-Semibold.eot
// module id = ../../../../../src/assets/fonts/Lato/fonts/Lato-Semibold.eot
// module chunks = styles